import { render } from "./OrdersList.vue?vue&type=template&id=f72a77fc&scoped=true"
import script from "./OrdersList.vue?vue&type=script&lang=js"
export * from "./OrdersList.vue?vue&type=script&lang=js"

import "./OrdersList.vue?vue&type=style&index=0&id=f72a77fc&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f72a77fc"]])

export default __exports__